import { getmetadata } from "../../js/lib/getmetadata";
import { bb } from "$json";

function storageAvailable(type) {
  var storage;
  try {
    storage = window[type];
    var x = "__storage_test__";
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return (
      e instanceof DOMException &&
      // everything except Firefox
      (e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === "QuotaExceededError" ||
        // Firefox
        e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
      // acknowledge QuotaExceededError only if there's something already stored
      storage &&
      storage.length !== 0
    );
  }
}

const level = s => s.match(/^ */)[0].length;

if (storageAvailable("localStorage")) {
  const store = window.localStorage;

  ((doc, $) => {
    $(doc).on("bb:preHandleData", (e, data) => {
      if (data && data.groups && data.groups.length && data.sessionid) {
        var metadata = getmetadata(data).props;
        // Check the metadata for 'jumplist-titles'
        if (metadata.has("jumplist-titles")) {
          // Loop through the titles and create an array of faux items for jumplist
          store.setItem(
            data.sessionid + "-fauxjumplist",
            metadata.get("jumplist-titles")
          );
        }
        // Cross reference the jumplist to the faux one and add what's needed
        let fauxjumplist = store.getItem(data.sessionid + "-fauxjumplist");
        if (fauxjumplist === null) {
          fauxjumplist = [];
        } else {
          fauxjumplist = fauxjumplist.split("|");
        }
        let unwanted = [];
        data.jumplist.forEach(item => {
          const index = fauxjumplist
            .map(title => title.trim())
            .indexOf(item.screentitle.trim());
          if (index > -1) {
            // fauxjumplist has this item, but so does the actual jumplist
            // so, we need to remove the item from fauxjumplist.
            fauxjumplist.splice(index, 1);
          } else {
            // Jumplist has this item, but it's not present in the fauxjumplist
            // so, we need to discard it from the actual jumplist.
            unwanted.push(item);
          }
        });
        unwanted.forEach(item => {
          let idx = data.jumplist.indexOf(item);
          data.jumplist.splice(idx, 1);
        });
        // Add items from the fauxjumplist to the actual jumplist:
        fauxjumplist.forEach(title => {
          let jumpitem = {
            screentitle: title,
            status: "future no-op",
            groupid: null,
            level: level(title)
          };
          data.jumplist.push(jumpitem);
        });
      }
    });
  })(document, jQuery);
} else {
  window.console &&
    window.console.warn("No localStorage, so can't persist with fauxjumplist");
}
